import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconSwap20pxRegular = function IconSwap20pxRegular(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 20 20",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.5 3.75a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5zM2.25 6.5a4.25 4.25 0 118.5 0 4.25 4.25 0 01-8.5 0z"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.5 10.75a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5zM9.25 13.5a4.25 4.25 0 118.5 0 4.25 4.25 0 01-8.5 0z"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.25 3a.75.75 0 01.75-.75h2A3.75 3.75 0 0117.75 6v2a.75.75 0 01-1.5 0V6A2.25 2.25 0 0014 3.75h-2a.75.75 0 01-.75-.75zM3 11.25a.75.75 0 01.75.75v2A2.25 2.25 0 006 16.25h2a.75.75 0 010 1.5H6A3.75 3.75 0 012.25 14v-2a.75.75 0 01.75-.75z"
    })]
  }));
};
export default IconSwap20pxRegular;